import type { SVGProps } from 'react'
const SvgSyViewHorizon = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width={24} height={24} {...props}>
		<path fillOpacity={0.24} d="M12.864 7.37a10 10 0 0 1-.143 9.523L4 12z" />
		<path d="M14.8 5.1a.5.5 0 0 0-.7.1c-1.3 1.732-3.711 3.253-5.922 4.347a38 38 0 0 1-4.71 1.937.58.58 0 0 0-.38.496c-.01.21.124.44.326.53.494.22 2.509 1.131 4.738 2.33 2.23 1.198 4.684 2.703 5.994 4.014a.5.5 0 0 0 .708 0 .5.5 0 0 0 0-.708c-1.475-1.474-3.962-2.97-6.227-4.187-1.836-.987-3.052-1.531-3.895-1.916.861-.3 2.06-.695 3.89-1.6 2.277-1.126 4.797-2.667 6.278-4.642a.5.5 0 0 0-.1-.701" />
		<path fillRule="evenodd" d="M13.55 9.033a10 10 0 0 1 0 5.933 3 3 0 0 1 0-5.933" clipRule="evenodd" />
		<path
			fillOpacity={0.24}
			d="M16.5 11.5a.5.5 0 0 0-.5.5.5.5 0 0 0 .5.5h4a.5.5 0 0 0 .5-.5.5.5 0 0 0-.5-.5zm3.824-3.969-4 1.5a.5.5 0 0 0-.293.645.5.5 0 0 0 .645.293l4-1.5a.5.5 0 0 0 .293-.645.5.5 0 0 0-.645-.293m-3.648 6.5a.5.5 0 0 0-.645.293.5.5 0 0 0 .293.645l4 1.5a.5.5 0 0 0 .645-.293.5.5 0 0 0-.293-.645z"
		/>
	</svg>
)
export default SvgSyViewHorizon
